export default "__VITE_ASSET__CZLMoaMA__"